import { default as React } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import ClickPicture from "./components/ClickPicture";
import Count from "./components/Count";
// import Game from "./components/Game";
import Home from "./components/Home";
import Login from "./components/Login";
import Register from "./components/Register";
import { db, messaging } from "./firebase";
import "./styles/main.css";

const registerServiceWorker = () => {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register("./firebase-messaging-sw.js")
      .then(function (registration) {
        console.log(
          "Registration successful, new scope is:",
          registration.scope
        );
      })
      .catch(function (err) {
        console.log("Service worker registration failed, error:", err);
      });
  }
};

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // Data 1st page
      name: "",
      email: "",
      employeId: "",
      familyName: "",
      accessMyPicture: false,
      consent: false,
      letProcedPage1: false,
      // data 2nd page
      registerTalentHunt: false,
      famjam: false,
      wheelOfFortune: false,
      letsPlay: false,
      sayCheese: false,
      // Data 3rd page
      clickPictureVisited: false,
      // Errors and messages
      redirect: false,
      completed: false,
    };
  }

  handleBasicRegistration = (data) => {
    this.setState({
      name: data.name,
      email: data.email,
      employeId: data.employeId,
      familyName: data.familyName,
      accessMyPicture: data.accessMyPicture,
      consent: data.consent,
      letProcedPage1: true,
    });
  };

  handleRegistration2 = (data) => {
    this.setState({
      registerTalentHunt: data.registerTalentHunt,
      famjam: data.famjam,
      wheelOfFortune: data.wheelOfFortune,
      letsPlay: data.letsPlay,
      sayCheese: data.sayCheese,
    });
  };

  handleFinishRegistration = async (data) => {
    const clickPictureVisited = data.clickPictureVisited;
    var consentUser;
    if (this.state.consent) {
      consentUser = {
        name: this.state.name,
        email: String(this.state.email).toLowerCase(),
      };
    } else {
      consentUser = false;
    }

    const userData = {
      name: this.state.name,
      email: String(this.state.email).toLowerCase(),
      employeId: String(this.state.employeId).toLowerCase(),
      familyName: this.state.familyName,
      accessMyPicture: this.state.accessMyPicture,
      consent: consentUser,
      activities: {
        famjam: this.state.famjam,
        wheelOfFortune: this.state.wheelOfFortune,
        letsPlay: this.state.letsPlay,
        sayCheese: this.state.sayCheese,
      },
      clickPictureVisited: clickPictureVisited,
      registerTalentHunt: this.state.registerTalentHunt,
      date: new Date(),
    };

    const docname = String(this.state.email).toLowerCase();
    var returnValue = await db
      .collection("users")
      .doc(docname)
      .set(userData)
      .then(() => {
        console.log("Data saved");
        return true;
      })
      .catch((error) => {
        console.log(error);
        return false;
      });
    console.log("app return value", returnValue);
    return returnValue;
  };

  // Firebase messaging
  componentDidMount() {
    try {
      messaging
        .requestPermission()
        .then(() => {
          return messaging.getToken();
        })
        .then((token) => {
          console.log(token);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log("iphone problem");
    }
  }

  render() {
    registerServiceWorker();
    return (
      <div className="App">
        <Switch>
          <Route path="/" exact render={() => <Home />} />

          <Route path="/login" render={() => <Login />} />

          <Route
            path="/register"
            exact
            render={(props) => (
              <Register
                {...props}
                state={this.state}
                handleBasicRegistration={this.handleBasicRegistration}
              />
            )}
          />
          {/* <Route
            path="/register2"
            exact
            render={(props) => (
              <Register2
                {...props}
                state={this.state}
                handleRegistration2={this.handleRegistration2}
              />
            )}
          /> */}

          {/* <Route path="/sapworld" exact render={() => <Game />} /> */}

          {/* <Route
            path="/welcome"
            render={(props) => <Welcome {...props} state={this.state} />}
          /> */}
          <Route
            path="/clickpicture"
            exact
            render={(props) => (
              <ClickPicture
                {...props}
                state={this.state}
                handleFinishRegistration={this.handleFinishRegistration}
              />
            )}
          />

          <Route
            path="/Gssb9iCshksSdf09bdAye67PmnmdfsdfsAAAA"
            exact
            render={() => <Count />}
          />

          <Route render={() => <Redirect to="/"></Redirect>} />
        </Switch>
      </div>
    );
  }
}

export default App;
